import { Component, Input, inject } from '@angular/core';
import { ModalService } from '../../services';

@Component({
  selector: 'lib-tooltip',
  styleUrls: ['tooltip.component.scss'],
  templateUrl: 'tooltip.component.html',
})
export class TooltipComponent {
  modalService = inject(ModalService);

  @Input() title!: string;
  @Input() tooltip!: string;
  @Input() smallIcon = false;

  get id() {
    return this.title?.toLowerCase().replace(/ /g, '-') ?? 'notification-tooltip';
  }

  openTooltip(triggerButton: HTMLElement) {
    this.modalService
      .open({
        title: this.title,
        message: this.tooltip,
        hideClose: true,
        showButtons: true,
        hideSubmit: true,
        cancelLabel: 'Close',
        defaultFocus: 'content',
      })
      .then(
        () => triggerButton.focus(),
        () => triggerButton.focus(),
      );
  }

  close() {
    this.modalService.close();
  }
}
